<template>
  <div style="width: 70px">
    <v-row no-gutters>
      <v-col cols="12">
        <v-progress-circular v-if="loading" color="primary" indeterminate size="18"
                             style="margin-top: 3px;margin-bottom: 2px" width="2"/>
        <v-badge v-else-if="searchCount>0" :content="searchCount" color="grey" class="pt-1" inline/>
        <v-badge v-else-if="unreadCount>0" :content="unreadCount" class="pt-1" inline/>
        <span v-else class="text-no-wrap"><v-icon>{{ icon }}</v-icon></span>
      </v-col>
      <v-col class="caption text-no-wrap" cols="12" style="font-size: 10px !important;">{{ name }}</v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  props: ['name', 'icon', 'unreadCount', 'searchCount', 'loading'],
}
</script>